import Restapi from "../api/Restapi";
import {REPORTING_URL, constats} from "../constant"

export const GetAllClass = async () => {
    const [AUTH_URL, REPORTING_URL] = await constats();
    return await Restapi('get',REPORTING_URL+'/apiv1/doctorclassmaster',null);
}

export const CreateClass= async (name,description,parentcategoryid) => {
    const data = {
        name,
        "desc":description,
    }
    const [AUTH_URL, REPORTING_URL] = await constats();
    return await Restapi('post',REPORTING_URL+'/apiv1/doctorclassmaster',data);
}

export const UpdateClassById = async (id,name,description,parentcategoryid) => {
    const data = {
        name,
        "desc":description,
    }
    const [AUTH_URL, REPORTING_URL] = await constats();
    return await Restapi('put',REPORTING_URL+'/apiv1/doctorclassmaster/'+id,data);
}

export const DeleteClassById = async (id) => {
    const [AUTH_URL, REPORTING_URL] = await constats();
    return await Restapi('delete',REPORTING_URL+'/apiv1/doctorclassmaster/'+id,null);
}

export const GetClassById = async (id) => {
    const [AUTH_URL, REPORTING_URL] = await constats();
    return await Restapi('get',REPORTING_URL+'/apiv1/doctorclassmaster/'+id,null);
}

export const ClassAvailableByName = async (name) => {
    const [AUTH_URL, REPORTING_URL] = await constats();
    return await Restapi('get',REPORTING_URL+'/apiv1/doctorclassmaster/getByName/'+name,null);
}